import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
export function Problem() {
  return <AnimatedSection className="py-24 px-6 max-w-4xl mx-auto text-center" data-id="element-128">
      <h2 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-129">El problema real</h2>
      <div className="space-y-6 text-lg md:text-xl text-left" data-id="element-130">
        <p data-id="element-131">
          Si tienes más de 65 años, probablemente te han dicho que el dolor
          articular es "parte de la edad". Te han recetado pastillas que te
          marean o te han sugerido dietas imposibles con ingredientes exóticos
          que no encuentras en una tienda común.
        </p>
        <p className="font-semibold text-brand-terracotta text-2xl text-center py-4" data-id="element-132">
          La realidad es que tu cuerpo no está "viejo", está inflamado.
        </p>
        <p data-id="element-133">
          Cada vez que consumes harinas blancas o aceites vegetales procesados,
          le echas gasolina al fuego de tus articulaciones. Por eso te
          despiertas con los dedos entumecidos y los tobillos hinchados.
        </p>
      </div>
    </AnimatedSection>;
}